import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagET = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M0 25c0 3.059.55 5.988 1.555 8.696L25 35.87l23.445-2.174A24.942 24.942 0 0 0 50 25.001a24.95 24.95 0 0 0-1.513-8.585L25 14.131 1.513 16.416A24.948 24.948 0 0 0 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c10.75 0 19.913-6.784 23.445-16.304H1.555C5.088 43.216 14.251 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 0C14.251 0 5.088 6.784 1.555 16.304h46.89C44.913 6.784 35.75 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 36.957c6.604 0 11.957-5.354 11.957-11.957 0-6.603-5.354-11.956-11.957-11.956-6.603 0-11.956 5.353-11.956 11.956 0 6.604 5.353 11.957 11.956 11.957Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m24.997 15.742 2.159 6.642h6.995L28.49 26.49l2.176 6.662-5.668-4.125-5.659 4.118 2.167-6.655-5.657-4.106h6.99l2.16-6.643Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m33.606 26.654-6.847-2.226 4.231-5.824-1.758-1.278L25 23.151l-4.232-5.825-1.758 1.278 4.231 5.825-6.847 2.224.672 2.068 6.847-2.225v7.2h2.174v-7.2l6.847 2.225.672-2.067Z"
}));
FlagET.displayName = 'FlagET';
export default withFlagWrapper(FlagET);
//# sourceMappingURL=index.js.map